import axiosInstance from "./axios";

const multipartConfig = { headers: { "Content-Type": "multipart/form-data" } };

export const getCardBgs = async ({ page, limit }) => {
    const response = await axiosInstance.get("/cardbg/find", { params: { page, limit } });
    return response.data;
};

export const createCardBg = async (file) => {
    const formData = new FormData();
    formData.append("CardBg", file);
    const response = await axiosInstance.post("/cardbg/create", formData, multipartConfig);
    return response.data;
};

export const updateCardBg = async (id, file) => {
    const formData = new FormData();
    formData.append("CardBg", file);
    const response = await axiosInstance.put(`/cardbg/update/${id}`, formData, multipartConfig);
    return response.data;
};

export const deleteCardBg = async (id) => {
    const response = await axiosInstance.delete(`/cardbg/delete/${id}`);
    return response.data;
};

export const deleteMultipleCardBgs = async (ids) => {
    const response = await axiosInstance.post("/cardbg/delete-multiple", { ids });
    return response.data;
};